// socialAuth.js — flags de l'espace membre & des connexions sociales.
// OAuth désactivé par défaut : s'active uniquement quand les client IDs sont fournis
// (Google Cloud Console / Facebook Developers) + le domaine OVH configuré.
const env = process.env;

// Facebook Connect coupé (décision produit). Passer à false pour le réactiver.
const FB_DISABLED = true;

export const socialAuth = {
  // Auth e-mail (Nakama authenticateEmail) : fonctionne en local sans config externe.
  emailEnabled: (env.REACT_APP_AUTH_EMAIL_ENABLED || 'true') !== 'false',
  // Invité (device auth) : toujours dispo, permet de jouer/chatter sans compte.
  guestEnabled: (env.REACT_APP_AUTH_GUEST_ENABLED || 'true') !== 'false',

  // Google Connect — nécessite un client ID OAuth + domaine autorisé.
  google: {
    enabled: !!env.REACT_APP_GOOGLE_CLIENT_ID,
    clientId: env.REACT_APP_GOOGLE_CLIENT_ID || '',
  },
  // Facebook Connect — DÉSACTIVÉ sur demande. Pour le réactiver : mettre FB_DISABLED à false
  // (et fournir REACT_APP_FACEBOOK_APP_ID). Google + e-mail + invité restent disponibles.
  facebook: {
    enabled: !FB_DISABLED && !!env.REACT_APP_FACEBOOK_APP_ID,
    appId: env.REACT_APP_FACEBOOK_APP_ID || '',
  },
};

// Vrai si au moins une connexion sociale est activée (pour afficher le séparateur).
export const anySocialEnabled = socialAuth.google.enabled || socialAuth.facebook.enabled;
